export const NO_RESPONSES_PLACEHOLDER = 'Why not get this spark started with a first pick?';

export const getNumberOfResponsesText = (numberOfResponses?: number): string => {
  if (numberOfResponses === undefined) {
    return '';
  }
  return `${numberOfResponses} response${numberOfResponses !== 1 ? 's' : ''}`;
};
